module.exports = __webpack_public_path__ + "img/15.8880a050.jpg";